import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ApiService } from 'src/app/service/apiServices';
import * as $ from "jquery";
import { Global } from '../../../global';
import { Location } from '@angular/common';
import { catchError } from 'rxjs/operators';
import { AuthService } from '../../../service/auth/auth.service'
import Swal from 'sweetalert2';

@Component({
  selector: 'app-servico-painel-senha',
  templateUrl: './servico-painel-senha.component.html',
  styleUrls: ['./servico-painel-senha.component.css']
})

export class ServicoPainelSenhaComponent implements OnInit {

  servico: any = {
    ativo: true
  };
  uid: any = null;
  loading: any = false;
  listaEstabelecimentos: any = [];

  constructor(
    private route: ActivatedRoute,
    public service: ApiService,
    private router: Router,
    public global: Global,
    private location: Location,
    private authService: AuthService
  ) { }

  goBack() {
    this.location.back();
  }

  ngOnInit() {
    Swal.fire('Favor aguarde');
    Swal.showLoading();
    this.carregarEstabelecimentos();
    const uid = this.route.snapshot.paramMap.get('uuid');
    this.uid = uid;
    if (this.uid) {
      this.obterServico(this.uid);
    } else {
      Swal.close();
    }
  }

  obterServico(id) {
    this.service.Get(`ServicoPainelSenha/${id}`).then(res => {
      Swal.close();
      this.loading = false;
      this.servico = res;
    }).catch(res => {
      Swal.close();
      this.loading = false;

      if (res && (res.status == 401 || (res.error && res.error.status == 401))) {
        this.authService.logoutUser()
        return;
      }

      if (res && res.error && res.error.erros && res.error.erros[0]) {
        Swal.fire('Erro', `${res.error.erros[0].messagem}`, 'error');
      } else {
        Swal.fire('Erro', 'Ocorreu um erro ao buscar o serviço', 'error');
      }
    });
  }

  carregarEstabelecimentos() {
    this.service.Get(`Estabelecimento?Ativo=true`).then((res: any) => {
      this.listaEstabelecimentos = res || [];
    }).catch(res => {
      if (res && (res.status == 401 || (res.error && res.error.status == 401))) {
        this.authService.logoutUser();
        return;
      }
      console.error('Erro ao carregar estabelecimentos:', res);
    });
  }

  salvar(item: any) {
    if (!item.nome) {
      Swal.fire('Atenção', `O nome do serviço é obrigatório`, 'warning');
      return
    }

    if (!item.sigla) {
      Swal.fire('Atenção', `A sigla do serviço é obrigatória`, 'warning');
      return
    }

    if (item.peso === null || item.peso === undefined) {
      Swal.fire('Atenção', `O peso do serviço é obrigatório`, 'warning');
      return
    }

    var obj = {
      "nome": item.nome,
      "descricao": item.descricao || "",
      "peso": item.peso,
      "sigla": item.sigla,
      "ativo": item.ativo,
      "estabelecimento_id": item.estabelecimento_id
    }

    this.loading = true;
    Swal.fire('Favor aguarde');
    Swal.showLoading();

    if (this.servico.id) {
      this.service.Put(`ServicoPainelSenha/${this.servico.id}`, obj).then(res => {
        Swal.close();
        this.loading = false;
        this.servico = res;
        Swal.fire({
          icon: 'success',
          title: 'Sucesso!',
          html: 'Serviço atualizado com sucesso!'
        }).then(
          result => {
            if (result.isConfirmed) {
              this.goBack();
            }
          }
        );
      }).catch(res => {
        Swal.close();
        this.loading = false;

        if (res && (res.status == 401 || (res.error && res.error.status == 401))) {
          this.authService.logoutUser()
          return;
        }

        if (res && res.error && res.error.erros && res.error.erros[0]) {
          Swal.fire('Erro', `${res.error.erros[0].messagem}`, 'error');
        } else {
          Swal.fire('Erro', 'Ocorreu um erro ao atualizar o serviço', 'error');
        }
      });
    } else {
      this.service.Post(`ServicoPainelSenha`, obj).then(res => {
        Swal.close();
        this.loading = false;
        this.servico = res;
        Swal.fire({
          icon: 'success',
          title: 'Sucesso!',
          html: 'Serviço criado com sucesso!'
        }).then(
          result => {
            if (result.isConfirmed) {
              this.goBack();
            }
          }
        );
      }).catch(res => {
        Swal.close();
        this.loading = false;

        if (res && (res.status == 401 || (res.error && res.error.status == 401))) {
          this.authService.logoutUser()
          return;
        }

        if (res && res.error && res.error.erros && res.error.erros[0]) {
          Swal.fire('Erro', `${res.error.erros[0].messagem}`, 'error');
        } else {
          Swal.fire('Erro', 'Ocorreu um erro ao criar o serviço', 'error');
        }
      });
    }
  }

  changeStatusestab() {
    // Toggle ativo
  }
}
